import { Stack, Text, Transition } from "@mantine/core";
import { useState } from "react";
import { OffLogo } from "../../shared/OffLogo";
import { StyledActionButton } from "../../shared/StyledActionButton";
import { TimedProgressBar } from "../../shared/TimedProgressBar";

type Props = {
  onNextButtonClick: () => void;
};

export function PostPersonalityTestInfoBreak({ onNextButtonClick }: Props) {
  const [showButton, setShowButton] = useState(false);

  return (
    <Stack align="center" justify="space-between" gap="xl" h="100%" pb="xl">
      <OffLogo />
      <Stack align="center" justify="center" style={{ flexGrow: 1 }}>
        <Text style={{ fontSize: "2rem" }}>🎯</Text>
        <Stack align="center" gap="xs">
          <Text size="lg">그룹 매칭 만족도 4.7/5</Text>
          <Text size="lg">레스토랑 만족도 4.6/5</Text>
          <Text size="lg">재참가 의사 4.9/5</Text>
        </Stack>
        <Text size="xl" ta="center" mt="lg">
          "나와 잘 맞는 그룹이라고
          <br />
          피드백을 남겨주시고 계세요"
        </Text>
      </Stack>

      <Stack h={50} align="center" justify="center" w="100%">
        {!showButton && (
          <TimedProgressBar duration={300} onTimerFinish={() => setShowButton(true)} />
        )}

        <Transition mounted={showButton} transition="fade" duration={400} timingFunction="ease">
          {(styles) => (
            <StyledActionButton style={styles} onClick={onNextButtonClick} w={300}>
              다음
            </StyledActionButton>
          )}
        </Transition>
      </Stack>
    </Stack>
  );
}
